import { IConfig } from './IConfig';

const development: IConfig = {
  // set this to zero to zero out the cache
  cacheMaxSize: 1024 * 1024 * 20,
  debug: true,
  edgeServer: process.env.REACT_APP_GRAPHQL_URL || '',
  featureFlagKey: 'TbYYe4Hd4aZcqWbUdpAiP',
};

const preprod: IConfig = {
  cacheMaxSize: 1024 * 1024 * 20,
  debug: false,
  edgeServer: process.env.REACT_APP_GRAPHQL_URL || '',
  featureFlagKey: 'Y8qrJyVLgK1T6oG6wAiec',
};

const production: IConfig = {
  cacheMaxSize: 1024 * 1024 * 20,
  debug: false,
  edgeServer: process.env.REACT_APP_GRAPHQL_URL || '',
  featureFlagKey: 'XwEUZ7UpbCGf9EcvX6zw4',
};

const test: IConfig = {
  cacheMaxSize: 1024 * 1024 * 20,
  debug: true,
  edgeServer: process.env.REACT_APP_GRAPHQL_URL || '',
  featureFlagKey: 'TbYYe4Hd4aZcqWbUdpAiP',
};

const GetConfig = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    case 'development':
      return development;
    case 'production':
      return production;
    case 'preprod':
      return preprod;
    case 'test':
      return test;
    default:
      return development;
  }
};

export { GetConfig };
